import React from 'react'
import './../styles/Loader.css'

const Loader: React.FC = () => {
  return (
    <div className='loader' />
  )
}

export default Loader
